module.exports = __webpack_public_path__ + "media/images/icon-a2fa1c69c2ed122e7de8defcbbeaf46a.svg";